/* tslint:disable */
/* eslint-disable */
/**
 * Web IMD-CONNECT.PRO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { RepairExtension } from '../models';
// @ts-ignore
import { RepairPlan } from '../models';
// @ts-ignore
import { RepairProof } from '../models';
// @ts-ignore
import { RepairProofImage } from '../models';
// @ts-ignore
import { WorkingImages } from '../models';
/**
 * AppsEmployeeApi - axios parameter creator
 * @export
 */
export const AppsEmployeeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Endpoint to add a new repair extension to a damage case
         * @param {RepairExtension} repairExtension 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsEmployeeRepairextensionPost: async (repairExtension: RepairExtension, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'repairExtension' is not null or undefined
            assertParamExists('appsEmployeeRepairextensionPost', 'repairExtension', repairExtension)
            const localVarPath = `/apps/employee/repairextension`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repairExtension, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to add a new repairplanTask to a damage case
         * @param {RepairPlan} repairPlan 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsEmployeeRepairplanPost: async (repairPlan: RepairPlan, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'repairPlan' is not null or undefined
            assertParamExists('appsEmployeeRepairplanPost', 'repairPlan', repairPlan)
            const localVarPath = `/apps/employee/repairplan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
						localVarRequestOptions.withCredentials = true;
            localVarRequestOptions.data = serializeDataIfNeeded(repairPlan, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to add repairproof image
         * @param {number} repairproofid 
         * @param {RepairProofImage} repairProofImage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsEmployeeRepairproofImageRepairproofidPost: async (repairproofid: number, repairProofImage: RepairProofImage, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'repairproofid' is not null or undefined
            assertParamExists('appsEmployeeRepairproofImageRepairproofidPost', 'repairproofid', repairproofid)
            // verify required parameter 'repairProofImage' is not null or undefined
            assertParamExists('appsEmployeeRepairproofImageRepairproofidPost', 'repairProofImage', repairProofImage)
            const localVarPath = `/apps/employee/repairproof/image/{repairproofid}`
                .replace(`{${"repairproofid"}}`, encodeURIComponent(String(repairproofid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repairProofImage, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to add repairproof
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsEmployeeRepairproofPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/apps/employee/repairproof`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to add workingimages to a damage case
         * @param {Array<WorkingImages>} workingImages 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsEmployeeWorkingimagesPost: async (workingImages: Array<WorkingImages>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workingImages' is not null or undefined
            assertParamExists('appsEmployeeWorkingimagesPost', 'workingImages', workingImages)
            const localVarPath = `/apps/employee/workingimages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workingImages, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppsEmployeeApi - functional programming interface
 * @export
 */
export const AppsEmployeeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppsEmployeeApiAxiosParamCreator(configuration)
    return {
        /**
         * Endpoint to add a new repair extension to a damage case
         * @param {RepairExtension} repairExtension 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appsEmployeeRepairextensionPost(repairExtension: RepairExtension, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appsEmployeeRepairextensionPost(repairExtension, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint to add a new repairplanTask to a damage case
         * @param {RepairPlan} repairPlan 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appsEmployeeRepairplanPost(repairPlan: RepairPlan, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appsEmployeeRepairplanPost(repairPlan, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint to add repairproof image
         * @param {number} repairproofid 
         * @param {RepairProofImage} repairProofImage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appsEmployeeRepairproofImageRepairproofidPost(repairproofid: number, repairProofImage: RepairProofImage, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appsEmployeeRepairproofImageRepairproofidPost(repairproofid, repairProofImage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint to add repairproof
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appsEmployeeRepairproofPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairProof>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appsEmployeeRepairproofPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint to add workingimages to a damage case
         * @param {Array<WorkingImages>} workingImages 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appsEmployeeWorkingimagesPost(workingImages: Array<WorkingImages>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appsEmployeeWorkingimagesPost(workingImages, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AppsEmployeeApi - factory interface
 * @export
 */
export const AppsEmployeeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppsEmployeeApiFp(configuration)
    return {
        /**
         * Endpoint to add a new repair extension to a damage case
         * @param {RepairExtension} repairExtension 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsEmployeeRepairextensionPost(repairExtension: RepairExtension, options?: any): AxiosPromise<void> {
            return localVarFp.appsEmployeeRepairextensionPost(repairExtension, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to add a new repairplanTask to a damage case
         * @param {RepairPlan} repairPlan 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsEmployeeRepairplanPost(repairPlan: RepairPlan, options?: any): AxiosPromise<void> {
            return localVarFp.appsEmployeeRepairplanPost(repairPlan, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to add repairproof image
         * @param {number} repairproofid 
         * @param {RepairProofImage} repairProofImage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsEmployeeRepairproofImageRepairproofidPost(repairproofid: number, repairProofImage: RepairProofImage, options?: any): AxiosPromise<void> {
            return localVarFp.appsEmployeeRepairproofImageRepairproofidPost(repairproofid, repairProofImage, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to add repairproof
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsEmployeeRepairproofPost(options?: any): AxiosPromise<RepairProof> {
            return localVarFp.appsEmployeeRepairproofPost(options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to add workingimages to a damage case
         * @param {Array<WorkingImages>} workingImages 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsEmployeeWorkingimagesPost(workingImages: Array<WorkingImages>, options?: any): AxiosPromise<void> {
            return localVarFp.appsEmployeeWorkingimagesPost(workingImages, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AppsEmployeeApi - object-oriented interface
 * @export
 * @class AppsEmployeeApi
 * @extends {BaseAPI}
 */
export class AppsEmployeeApi extends BaseAPI {
    /**
     * Endpoint to add a new repair extension to a damage case
     * @param {RepairExtension} repairExtension 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppsEmployeeApi
     */
    public appsEmployeeRepairextensionPost(repairExtension: RepairExtension, options?: AxiosRequestConfig) {
        return AppsEmployeeApiFp(this.configuration).appsEmployeeRepairextensionPost(repairExtension, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to add a new repairplanTask to a damage case
     * @param {RepairPlan} repairPlan 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppsEmployeeApi
     */
    public appsEmployeeRepairplanPost(repairPlan: RepairPlan, options?: AxiosRequestConfig) {
        return AppsEmployeeApiFp(this.configuration).appsEmployeeRepairplanPost(repairPlan, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to add repairproof image
     * @param {number} repairproofid 
     * @param {RepairProofImage} repairProofImage 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppsEmployeeApi
     */
    public appsEmployeeRepairproofImageRepairproofidPost(repairproofid: number, repairProofImage: RepairProofImage, options?: AxiosRequestConfig) {
        return AppsEmployeeApiFp(this.configuration).appsEmployeeRepairproofImageRepairproofidPost(repairproofid, repairProofImage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to add repairproof
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppsEmployeeApi
     */
    public appsEmployeeRepairproofPost(options?: AxiosRequestConfig) {
        return AppsEmployeeApiFp(this.configuration).appsEmployeeRepairproofPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to add workingimages to a damage case
     * @param {Array<WorkingImages>} workingImages 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppsEmployeeApi
     */
    public appsEmployeeWorkingimagesPost(workingImages: Array<WorkingImages>, options?: AxiosRequestConfig) {
        return AppsEmployeeApiFp(this.configuration).appsEmployeeWorkingimagesPost(workingImages, options).then((request) => request(this.axios, this.basePath));
    }
}
